(function() {
  'use strict';

  var root = window.IBAerosolLimit || {};
  var cfg = root.config;

  if (!cfg || !Array.isArray(cfg.gatedSkus)) {
    return;
  }

  cfg.gatedSkus = cfg.gatedSkus.map(function(sku) {
    return String(sku == null ? '' : sku).trim();
  }).filter(Boolean);

  if (!cfg.gatedSkus.length) {
    return;
  }

  var perSkuCartAllowance = Math.max(0, toNumber(cfg.max, 0));
  var gatedSkuSet = {};
  cfg.gatedSkus.forEach(function(sku) {
    gatedSkuSet[sku] = true;
  });

  var lastCart = null;
  var cartMutationMayContainGatedSku = false;
  var cartRequest = null;
  var cartNormalizeRequest = null;
  var cartRefreshTimer = null;
  // Generation of the newest optimistic add still awaiting its authoritative cart
  // event. optimisticCartCount.bump stamps a monotonic generation on both the
  // optimistic event and that same add's authoritative event, so the consume
  // branch can cancel a pending verification read only once it sees the
  // authoritative event for THIS generation — a rapid newer add's fail-closed
  // read is never dropped by an older add's authoritative event landing first.
  // Generation is used instead of item_count because a stale count badge makes
  // the projected count wrong (then a correct authoritative cart would fail a
  // count comparison and the read would fire needlessly).
  var cartRefreshTargetGeneration = null;
  // A pending UNCORRELATED self-heal obligation: a non-optimistic may-affect event
  // (e.g. a stateless cart:build from an out-of-band Swym add) armed a read whose
  // only job is to read the true post-write cart. It carries no generation, so it
  // is tracked separately from cartRefreshTargetGeneration — an authoritative add
  // can cancel only its OWN generation read and can never consume this obligation,
  // regardless of which event armed the shared timer first. Cleared only when the
  // read actually fires.
  var cartRefreshSelfHealPending = false;
  // Optimistic add events fire BEFORE the serialized write resolves; a real add
  // round-trip usually exceeds 150ms, so the optimistic backstop must be long
  // enough for the authoritative event to land and cancel the read first — else
  // the read fires anyway and the footprint win is lost. 2500ms mirrors the
  // cart:quantity backstop.
  var CART_REFRESH_MS = 150;
  var CART_OPTIMISTIC_REFRESH_MS = 2500;
  // Quantity mutations are tracked PER LINE KEY, not as one global flag. Two
  // gated lines can be edited within the same ~2.5s window; each line's trailing
  // cart:updated (source 'cart-quantity') threads its own detail.cartQuantityKey,
  // so it discharges only ITS line. A single global flag let the first line's
  // trailing event clear the second line's pending state AND its backstop while
  // that second (possibly over-cap) increase was still in flight — a fail-open.
  // Map: line key -> per-key 2500ms backstop timer id. Checkout stays disabled
  // while ANY key is pending.
  var cartQuantityPendingKeys = {};
  var CART_QUANTITY_BACKSTOP_MS = 2500;
  var CART_UNAVAILABLE_MESSAGE = 'Unable to verify aerosol limits right now. Please try again before checkout.';
  var CART_PENDING_MESSAGE = 'Checking aerosol order limits. Please try again in a moment.';
  var CART_LINE_KEY_MISSING_MESSAGE = 'Unable to safely update aerosol quantities automatically. Please refresh your cart and try again before checkout.';

  function fetchCart(force) {
    if (!force && cartRequest) {
      return cartRequest;
    }

    // Don't read /cart.js while an edge challenge is active. Degrade through the
    // existing "cart unreadable" path so cart and product limit checks can fail
    // closed without hammering the challenged origin. Tag the sentinel so the
    // block message can prefer the "refresh and try again" challenge copy.
    if (theme.cart && theme.cart.isChallengeActive && theme.cart.isChallengeActive()) {
      return Promise.resolve({
        items: [],
        __aerosolLimitUnreadable: true,
        __securityChallenge: true
      });
    }

    cartRequest = theme.cart.getCart()
      .then(function(cart) {
        if (!cart) {
          throw new Error('Cart fetch failed');
        }
        return cart;
      })
      .then(function(cart) {
        return trackKnownCart(cart);
      })
      .catch(function(error) {
        console.warn('Aerosol limit cart check failed:', error);
        return {
          items: [],
          __aerosolLimitUnreadable: true,
          error: error
        };
      })
      .finally(function() {
        cartRequest = null;
      });

    return cartRequest;
  }

  function toNumber(value, fallback) {
    var parsed = parseInt(value, 10);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function skuLabel(sku) {
    var label = cfg.skuLabels && cfg.skuLabels[sku];
    return label ? label + ' (' + sku + ')' : sku;
  }

  function getCartQtyBySku(cart) {
    var out = {};

    (cart.items || []).forEach(function(item) {
      if (item && gatedSkuSet[item.sku]) {
        out[item.sku] = (out[item.sku] || 0) + item.quantity;
      }
    });

    return out;
  }

  function cartForms() {
    return document.querySelectorAll('#CartPageForm, .cart__drawer-form');
  }

  function cartContainsGatedSku(cart) {
    return (cart && cart.items || []).some(function(item) {
      return item && gatedSkuSet[item.sku];
    });
  }

  function cartFormsKnowGatedSku() {
    return Boolean(document.querySelector('#CartPageForm[data-aerosol-limit-cart-has-gated="true"], .cart__drawer-form[data-aerosol-limit-cart-has-gated="true"]'));
  }

  function cartKnownToContainGatedSku(cart) {
    if (cart && !cartIsUnreadable(cart)) {
      return cartContainsGatedSku(cart);
    }

    return cartMutationMayContainGatedSku || cartContainsGatedSku(lastCart) || cartFormsKnowGatedSku();
  }

  function setCartFormsKnownGated(hasGatedSku) {
    cartForms().forEach(function(form) {
      if (hasGatedSku) {
        form.dataset.aerosolLimitCartHasGated = 'true';
      } else {
        delete form.dataset.aerosolLimitCartHasGated;
      }
    });
  }

  function getCartQtyByVariant(cart) {
    var out = {};

    (cart.items || []).forEach(function(item) {
      if (item && item.id != null) {
        out[String(item.id)] = (out[String(item.id)] || 0) + item.quantity;
      }
    });

    return out;
  }

  function getPerSkuCartAllowance() {
    return perSkuCartAllowance;
  }

  function getProductAddAllowance(sku, cartQtyBySku) {
    return Math.max(0, getPerSkuCartAllowance() - (cartQtyBySku[sku] || 0));
  }

  function temporaryLimitMessage() {
    return 'Temporary availability limit: maximum ' + getPerSkuCartAllowance() + ' per order. We apologize for any inconvenience.';
  }

  function isFiniteLimit(value) {
    return Number.isFinite(value) && value < 999999;
  }

  function cartIsUnreadable(cart) {
    return Boolean(cart && cart.__aerosolLimitUnreadable);
  }

  function cartIsSecurityChallenge(cart) {
    return Boolean(cart && cart.__securityChallenge);
  }

  // Prefer the cart's "refresh and try again" challenge copy when the cart is
  // unreadable because an edge challenge is active. Falls back to the generic
  // "couldn't verify" message when theme.cart exposes no challenge copy.
  function cartUnavailableMessage(cart) {
    if (cartIsSecurityChallenge(cart)) {
      var challenge = theme.cart && theme.cart.challenge;
      var challengeError = challenge && challenge.suppressedError && challenge.suppressedError();
      var challengeMessage = challengeError && challengeError.userMessage;
      if (challengeMessage) {
        return challengeMessage;
      }
    }
    return CART_UNAVAILABLE_MESSAGE;
  }

  function setLiveRegionAttributes(container, isError) {
    container.setAttribute('role', isError ? 'alert' : 'status');
    container.setAttribute('aria-live', isError ? 'assertive' : 'polite');
    container.setAttribute('aria-atomic', 'true');
  }

  function showInlineMessage(container, message, isError) {
    if (!container) {
      return;
    }

    setLiveRegionAttributes(container, Boolean(isError));
    container.textContent = message;
    container.hidden = false;
    container.classList.toggle('aerosol-limit-message--error', Boolean(isError));
  }

  function showTransientFormMessage(form, message, isError) {
    var messageEl = form.querySelector('[data-aerosol-limit-product-message]');
    if (!messageEl) {
      messageEl = document.createElement('div');
      messageEl.className = 'aerosol-limit-message';
      messageEl.setAttribute('data-aerosol-limit-product-message', '');
      form.insertBefore(messageEl, form.firstChild);
    }

    showInlineMessage(messageEl, message, isError !== false);
  }

  function ensureLiveRegion() {
    var liveRegion = document.getElementById('hc-cart-live-region') || document.getElementById('aerosol-limit-live-region');
    if (liveRegion) {
      return liveRegion;
    }

    liveRegion = document.createElement('div');
    liveRegion.id = 'aerosol-limit-live-region';
    liveRegion.className = 'visually-hidden';
    liveRegion.setAttribute('role', 'status');
    liveRegion.setAttribute('aria-live', 'polite');
    liveRegion.setAttribute('aria-atomic', 'true');
    document.body.appendChild(liveRegion);
    return liveRegion;
  }

  function showToast(title, detail, isError) {
    var liveRegion = ensureLiveRegion();
    var message = detail ? title + '. ' + detail : title;

    if (liveRegion) {
      liveRegion.textContent = message;
      window.setTimeout(function() {
        liveRegion.textContent = '';
      }, 3000);
    }

    if (window.Theme && typeof window.Theme.showToast === 'function') {
      window.Theme.showToast({ title: title, message: detail, type: isError ? 'error' : 'info' });
      return;
    }

    var container = document.body.querySelector(':scope > .cg-toast-container');
    if (!container) {
      container = document.createElement('div');
      container.className = 'cg-toast-container';
      container.setAttribute('popover', 'manual');
      document.body.appendChild(container);
    }

    var popoverIsOpen = false;
    if (container.matches) {
      try {
        popoverIsOpen = container.matches(':popover-open');
      } catch (error) {
        popoverIsOpen = false;
      }
    }

    if (container.showPopover && !popoverIsOpen) {
      try {
        container.showPopover();
      } catch (error) {}
    }

    var toast = document.createElement('div');
    toast.className = 'cg-toast';
    if (isError) {
      toast.classList.add('aerosol-limit-toast--error');
    }

    var textWrap = document.createElement('div');
    textWrap.className = 'cg-toast__text';

    var line1 = document.createElement('div');
    line1.className = 'cg-toast__line';
    line1.textContent = title;

    var line2 = document.createElement('div');
    line2.className = 'cg-toast__line cg-toast__line--meta';
    line2.textContent = detail || '';

    textWrap.appendChild(line1);
    if (detail) {
      textWrap.appendChild(line2);
    }
    toast.appendChild(textWrap);
    container.appendChild(toast);

    window.requestAnimationFrame(function() {
      toast.classList.add('is-visible');
    });

    window.setTimeout(function() {
      toast.classList.remove('is-visible');
      window.setTimeout(function() {
        toast.remove();
        if (!container.hasChildNodes()) {
          if (container.hidePopover) {
            try {
              container.hidePopover();
            } catch (error) {}
          }
          container.remove();
        }
      }, 300);
    }, 3000);
  }

  function initProductLimit(scriptEl) {
    var productCfg;

    try {
      productCfg = JSON.parse(scriptEl.textContent);
    } catch (error) {
      console.warn('Aerosol limit product config could not be parsed:', error);
      return;
    }

    var productSection = scriptEl.closest('.product-section') || document;
    var form = scriptEl.closest('form') || productSection.querySelector('.product-single__form');
    var notice = productSection.querySelector('[data-aerosol-limit-product-message]');

    if (!form || !productCfg.variantSkuMap) {
      return;
    }

    function selectedVariantId() {
      var selector = form.querySelector('[name="id"]') || form.querySelector('[data-product-select]');
      return selector && selector.value ? String(selector.value) : null;
    }

    function selectedSku() {
      var variantId = selectedVariantId();
      return variantId ? productCfg.variantSkuMap[variantId] : null;
    }

    function isSelectedVariantAvailable() {
      var variantId = selectedVariantId();
      if (!variantId || !productCfg.variantAvailabilityMap) {
        return true;
      }
      return productCfg.variantAvailabilityMap[variantId] !== false;
    }

    function firstNamedControl(namedControl) {
      if (!namedControl) {
        return null;
      }

      if (namedControl.nodeType === 1) {
        return namedControl;
      }

      if (typeof namedControl.length === 'number') {
        for (var i = 0; i < namedControl.length; i++) {
          if (namedControl[i] && namedControl[i].nodeType === 1) {
            return namedControl[i];
          }
        }
      }

      return null;
    }

    function qtyInput() {
      var formOwnedInput = firstNamedControl(form.elements && form.elements.namedItem('quantity'));

      if (formOwnedInput) {
        return formOwnedInput;
      }

      var sectionInputs = productSection.querySelectorAll('[name="quantity"]');
      for (var i = 0; i < sectionInputs.length; i++) {
        if (sectionInputs[i].form === form || (form.id && sectionInputs[i].getAttribute('form') === form.id)) {
          return sectionInputs[i];
        }
      }

      return form.querySelector('[name="quantity"]');
    }

    function addButton() {
      return form.querySelector('[data-add-to-cart], [name="add"], .add-to-cart');
    }

    function clearAerosolMaxOverride(input) {
      if (input.dataset.aerosolLimitApplied === 'true') {
        if (input.getAttribute('max') === input.dataset.aerosolEffectiveMax) {
          input.setAttribute('max', input.dataset.aerosolBaseMax || '');
        }
        delete input.dataset.aerosolLimitApplied;
        delete input.dataset.aerosolEffectiveMax;
      }
    }

    function captureBaseMax(input, variantId) {
      clearAerosolMaxOverride(input);
      if (input.dataset.aerosolBaseVariant !== variantId) {
        var mappedMax = productCfg.variantMaxMap && productCfg.variantMaxMap[variantId];
        input.dataset.aerosolBaseVariant = variantId || '';
        input.dataset.aerosolBaseMax = mappedMax != null ? String(mappedMax) : input.getAttribute('max') || '';
      }
      return toNumber(input.dataset.aerosolBaseMax, 9999999);
    }

    function setButtonAerosolDisabled(button, disabled) {
      if (!button) {
        return;
      }

      if (disabled) {
        button.dataset.aerosolLimitDisabled = 'true';
        button.disabled = true;
        button.classList.add('disabled');
        button.setAttribute('aria-disabled', 'true');
      } else if (button.dataset.aerosolLimitDisabled === 'true') {
        delete button.dataset.aerosolLimitDisabled;
        button.disabled = false;
        button.classList.remove('disabled');
        button.removeAttribute('aria-disabled');
      }
    }

    function restoreProductControls(cart) {
      var input = qtyInput();
      var button = addButton();
      var shouldDisable = !isSelectedVariantAvailable();

      if (input) {
        var variantId = selectedVariantId();
        var baseMax = captureBaseMax(input, variantId);
        var cartQtyByVariant = getCartQtyByVariant(cart || { items: [] });
        var variantCartQty = cartQtyByVariant[variantId] || 0;
        clearAerosolMaxOverride(input);
        if (isFiniteLimit(baseMax) && baseMax - variantCartQty <= 0) {
          shouldDisable = true;
        }
      }

      setButtonAerosolDisabled(button, shouldDisable);

      if (notice) {
        notice.hidden = true;
      }
    }

    function applyProductLimit(cart) {
      var sku = selectedSku();

      if (!sku) {
        restoreProductControls(cart);
        return;
      }

      var input = qtyInput();
      var button = addButton();

      if (cartIsUnreadable(cart)) {
        setButtonAerosolDisabled(button, true);
        if (notice) {
          showInlineMessage(notice, cartUnavailableMessage(cart), true);
        }
        return;
      }

      var variantId = selectedVariantId();
      var cartQtyBySku = getCartQtyBySku(cart);
      var cartQtyByVariant = getCartQtyByVariant(cart);
      var skuAllowance = getProductAddAllowance(sku, cartQtyBySku);
      var skuLimitActive = skuAllowance < getPerSkuCartAllowance();
      var allowedNow = skuAllowance;

      if (input) {
        var baseMax = captureBaseMax(input, variantId);
        var variantCartQty = cartQtyByVariant[variantId] || 0;
        var inventoryAllowance = isFiniteLimit(baseMax) ? Math.max(0, baseMax - variantCartQty) : baseMax;

        allowedNow = Math.min(skuAllowance, inventoryAllowance);
        var effectiveMax = allowedNow + variantCartQty;
        if (isFiniteLimit(baseMax)) {
          effectiveMax = Math.min(baseMax, effectiveMax);
        }
        input.dataset.aerosolLimitApplied = 'true';
        input.dataset.aerosolEffectiveMax = String(effectiveMax);
        input.setAttribute('max', String(effectiveMax));

        var currentValue = toNumber(input.value, 1);
        if (allowedNow <= 0) {
          input.value = '0';
        } else if (currentValue > allowedNow) {
          input.value = String(allowedNow);
        } else if (currentValue < 1) {
          input.value = '1';
        }
      }

      setButtonAerosolDisabled(button, allowedNow <= 0 || !isSelectedVariantAvailable());

      if (notice) {
        if (skuLimitActive) {
          showInlineMessage(notice, temporaryLimitMessage(), skuAllowance <= 0);
        } else {
          notice.hidden = true;
        }
      }
    }

    function refreshProductLimitWithCart(cart) {
      window.setTimeout(function() {
        applyProductLimit(cart);
      }, 0);
    }

    function refreshProductLimit(forceCart) {
      window.setTimeout(function() {
        fetchCart(forceCart).then(applyProductLimit);
      }, 0);
    }

    function preventProductSubmit(event) {
      if (!event) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
    }

    function submitLimitAllowsCart(cart, event) {
      var sku = selectedSku();

      if (!sku) {
        return true;
      }

      if (cartIsUnreadable(cart)) {
        preventProductSubmit(event);
        setButtonAerosolDisabled(addButton(), true);
        showTransientFormMessage(form, cartUnavailableMessage(cart), true);
        showToast('Unable to verify cart', cartUnavailableMessage(cart), true);
        return false;
      }

      var allowedNow = getProductAddAllowance(sku, getCartQtyBySku(cart));
      var input = qtyInput();
      var requested = toNumber(input && input.value, 1);

      if (requested > allowedNow) {
        if (input && allowedNow > 0) {
          input.value = String(allowedNow);
          var limitMessage = temporaryLimitMessage();
          var reducedMessage = 'Quantity reduced. ' + limitMessage;
          showTransientFormMessage(form, reducedMessage, false);
          showToast('Quantity reduced', limitMessage, false);
          return true;
        }

        var message = temporaryLimitMessage();
        preventProductSubmit(event);
        showTransientFormMessage(form, message, true);
        showToast('Limit reached', message, true);
        return false;
      }

      return true;
    }

    function currentCartBeforeSubmit() {
      if (cartNormalizeRequest) {
        return cartNormalizeRequest.then(function() {
          return fetchCart(true);
        });
      }

      return cartRequest || fetchCart(true);
    }

    var allowVerifiedSubmit = false;

    form.addEventListener('submit', function(event) {
      var sku = selectedSku();

      if (!sku) {
        return;
      }

      if (allowVerifiedSubmit) {
        allowVerifiedSubmit = false;
        return;
      }

      var submitter = event.submitter || addButton();
      preventProductSubmit(event);

      currentCartBeforeSubmit()
        .then(function(cart) {
          applyProductLimit(cart);

          if (!submitLimitAllowsCart(cart, null)) {
            return;
          }

          allowVerifiedSubmit = true;
          if (form.requestSubmit) {
            if (submitter && submitter.form === form) {
              form.requestSubmit(submitter);
            } else {
              form.requestSubmit();
            }
          } else {
            form.submit();
          }
        })
        .catch(function(error) {
          console.warn('Aerosol limit submit check failed:', error);
          submitLimitAllowsCart({
            items: [],
            __aerosolLimitUnreadable: true,
            error: error
          }, null);
        });

      return false;
    }, true);

    document.addEventListener('variant:change', function() {
      refreshProductLimit(false);
    });

    form.addEventListener('change', function(event) {
      if (event.target && event.target.matches('[name="quantity"], [name="id"], [data-product-select]')) {
        refreshProductLimit(false);
      }
    });

    form.addEventListener('click', function(event) {
      if (event.target && event.target.closest('.js-qty__adjust')) {
        refreshProductLimit(false);
      }
    });

    scriptEl.addEventListener('aerosol-limit:refresh-product', function(event) {
      var detail = event && event.detail ? event.detail : {};
      var cart = theme.cart.getCartState(detail);
      if (cart && Array.isArray(cart.items)) {
        refreshProductLimitWithCart(cart);
        return;
      }

      refreshProductLimit(true);
    });

    refreshProductLimit(true);
  }

  function cartOverages(cart) {
    var bySku = getCartQtyBySku(cart);

    return cfg.gatedSkus.reduce(function(overages, sku) {
      var cartQty = bySku[sku] || 0;
      var allowance = getPerSkuCartAllowance();

      if (cartQty > allowance) {
        overages.push({
          sku: sku,
          label: skuLabel(sku),
          cartQty: cartQty,
          allowance: allowance,
          overBy: cartQty - allowance
        });
      }

      return overages;
    }, []);
  }

  function cartAdjustmentPlan(cart) {
    var remainingBySku = {};

    cfg.gatedSkus.forEach(function(sku) {
      remainingBySku[sku] = getPerSkuCartAllowance();
    });

    return (cart.items || []).reduce(function(plan, item) {
      if (!item || !gatedSkuSet[item.sku]) {
        return plan;
      }

      var currentQty = toNumber(item.quantity, 0);
      var remaining = Math.max(0, remainingBySku[item.sku] || 0);
      var targetQty = Math.min(currentQty, remaining);
      remainingBySku[item.sku] = Math.max(0, remaining - targetQty);

      if (targetQty < currentQty) {
        if (!item.key) {
          plan.missingKeyItems.push({
            sku: item.sku,
            label: skuLabel(item.sku),
            from: currentQty,
            to: targetQty
          });
          return plan;
        }

        plan.adjustments.push({
          key: item.key,
          sku: item.sku,
          label: skuLabel(item.sku),
          from: currentQty,
          to: targetQty
        });
      }

      return plan;
    }, {
      adjustments: [],
      missingKeyItems: []
    });
  }

  function cartAdjustments(cart) {
    return cartAdjustmentPlan(cart).adjustments;
  }

  function cartMessage(overages) {
    if (!overages.length) {
      return '';
    }

    return temporaryLimitMessage() + ' Please reduce the quantity to continue.';
  }

  function cartAdjustmentMessage(adjustments) {
    if (!adjustments.length) {
      return '';
    }

    return temporaryLimitMessage();
  }

  function ensureCartNotice(form) {
    var notice = form.querySelector('[data-aerosol-limit-cart-message]');
    if (notice) {
      return notice;
    }

    notice = document.createElement('div');
    notice.className = 'aerosol-limit-message aerosol-limit-message--error';
    notice.setAttribute('data-aerosol-limit-cart-message', '');
    setLiveRegionAttributes(notice, true);

    var checkoutWrapper = form.querySelector('.cart__checkout-wrapper');
    if (checkoutWrapper && checkoutWrapper.parentNode) {
      checkoutWrapper.parentNode.insertBefore(notice, checkoutWrapper);
    } else {
      form.insertBefore(notice, form.firstChild);
    }

    return notice;
  }

  function setCheckoutBlocked(form, blocked, message) {
    delete form.dataset.aerosolLimitPending;
    form.dataset.aerosolLimitBlocked = blocked ? 'true' : 'false';

    var notice = ensureCartNotice(form);
    if (blocked) {
      showInlineMessage(notice, message, true);
    } else {
      notice.hidden = true;
    }

    form.querySelectorAll('[name="checkout"], .cart__checkout, [data-checkout]').forEach(function(button) {
      if (blocked) {
        button.dataset.aerosolLimitDisabled = 'true';
        button.disabled = true;
        button.classList.add('disabled');
        button.setAttribute('aria-disabled', 'true');
        button.title = message || temporaryLimitMessage();
      } else if (button.dataset.aerosolLimitDisabled === 'true') {
        delete button.dataset.aerosolLimitDisabled;
        button.disabled = false;
        button.classList.remove('disabled');
        button.removeAttribute('aria-disabled');
        button.removeAttribute('title');
      }
    });

    form.querySelectorAll('shopify-accelerated-checkout, shopify-accelerated-checkout-cart, [data-shopify="dynamic-checkout-cart"], .additional-checkout-buttons').forEach(function(el) {
      if (blocked) {
        el.dataset.aerosolLimitHidden = 'true';
        el.style.display = 'none';
      } else if (el.dataset.aerosolLimitHidden === 'true') {
        delete el.dataset.aerosolLimitHidden;
        el.style.display = '';
      }
    });
  }

  function setCheckoutPending(form, message) {
    if (form.dataset.aerosolLimitBlocked === 'true') {
      return;
    }

    form.dataset.aerosolLimitPending = 'true';
    form.dataset.aerosolLimitBlocked = 'false';

    form.querySelectorAll('[name="checkout"], .cart__checkout, [data-checkout]').forEach(function(button) {
      button.dataset.aerosolLimitDisabled = 'true';
      button.disabled = true;
      button.classList.add('disabled');
      button.setAttribute('aria-disabled', 'true');
      button.title = message || CART_PENDING_MESSAGE;
    });

    form.querySelectorAll('shopify-accelerated-checkout, shopify-accelerated-checkout-cart, [data-shopify="dynamic-checkout-cart"], .additional-checkout-buttons').forEach(function(el) {
      el.dataset.aerosolLimitHidden = 'true';
      el.style.display = 'none';
    });
  }

  function setCartFormsPending(message) {
    cartForms().forEach(function(form) {
      setCheckoutPending(form, message);
    });
  }

  function refreshProductLimits(cart) {
    var eventOptions = cart && Array.isArray(cart.items) ? {
      detail: {
        cartState: cart,
        cart: cart
      }
    } : undefined;

    document.querySelectorAll('[data-aerosol-limit-product]').forEach(function(scriptEl) {
      scriptEl.dispatchEvent(new CustomEvent('aerosol-limit:refresh-product', eventOptions));
    });
  }

  function normalizeCart(cart, plan) {
    if (cartNormalizeRequest) {
      return cartNormalizeRequest;
    }

    plan = plan || cartAdjustmentPlan(cart);
    if (plan.missingKeyItems.length) {
      return Promise.reject(new Error('Aerosol cart line is missing a line item key.'));
    }

    var adjustments = plan.adjustments;
    if (!adjustments.length) {
      return Promise.resolve(cart);
    }

    var adjustedMessage = cartAdjustmentMessage(adjustments);

    var updates = {};
    adjustments.forEach(function(adjustment) {
      updates[adjustment.key] = adjustment.to;
    });

    // One update.js call reduces every line at once, and the broadcast keeps
    // the returned section HTML so the drawer re-renders without a refetch.
    cartNormalizeRequest = theme.cart.updateCartAndBroadcast(updates, {
      source: 'aerosol-limit'
    })
      .then(function(result) {
        var updatedCart = theme.cart.getCartState(result) || result;
        lastCart = updatedCart;
        showToast('Quantity reduced', adjustedMessage, false);
        refreshProductLimits();
        return updatedCart;
      })
      .catch(function(error) {
        console.warn('Aerosol limit cart adjustment failed:', error);
        // Surface the challenge message when present so a Cloudflare check reads
        // as "refresh and try again" rather than a generic normalization failure.
        showToast('Cart update failed', (error && error.userMessage) || 'Unable to reduce aerosol quantities automatically. Please update your cart before checkout.', true);
        throw error;
      })
      .finally(function() {
        cartNormalizeRequest = null;
      });

    return cartNormalizeRequest;
  }

  function applyCartGuard(cart) {
    if (hasPendingCartQuantity()) {
      return;
    }

    if (cartIsUnreadable(cart)) {
      var shouldFailClosed = cartKnownToContainGatedSku();
      var unavailableMessage = cartUnavailableMessage(cart);

      cartForms().forEach(function(form) {
        setCheckoutBlocked(form, shouldFailClosed, shouldFailClosed ? unavailableMessage : '');
      });
      return;
    }

    setCartFormsKnownGated(cartContainsGatedSku(cart));

    var plan = cartAdjustmentPlan(cart);
    if (plan.missingKeyItems.length) {
      cartForms().forEach(function(form) {
        setCheckoutBlocked(form, true, CART_LINE_KEY_MISSING_MESSAGE);
      });
      return;
    }

    var adjustments = plan.adjustments;

    if (adjustments.length) {
      var adjustmentMessage = 'Updating quantities. ' + temporaryLimitMessage();

      cartForms().forEach(function(form) {
        setCheckoutBlocked(form, true, adjustmentMessage);
      });

      normalizeCart(cart, plan)
        .then(function(updatedCart) {
          applyCartGuard(updatedCart);
        })
        .catch(function() {
          var overages = cartOverages(cart);
          var message = cartMessage(overages);

          cartForms().forEach(function(form) {
            setCheckoutBlocked(form, true, message);
          });
        });

      return;
    }

    var overages = cartOverages(cart);
    var blocked = overages.length > 0;
    var message = cartMessage(overages);

    cartForms().forEach(function(form) {
      setCheckoutBlocked(form, blocked, message);
    });
  }

  function refreshCartGuard(forceCart) {
    fetchCart(forceCart).then(function(cart) {
      applyCartGuard(cart);
    });
  }

  function eventCart(event) {
    var detail = eventDetail(event);
    return theme.cart.getCartState(detail);
  }

  function eventDetail(event) {
    return event && event.detail ? event.detail : {};
  }

  function eventProductSku(event) {
    var product = eventDetail(event).product;
    var sku = product && (product.sku || product.variant_sku);
    return sku == null ? '' : String(sku).trim();
  }

  function isUnverifiedCartMutationEvent(event) {
    var detail = eventDetail(event);
    if (eventCart(event)) {
      return false;
    }

    if (detail.lightweight && detail.source === 'collection-atc') {
      return false;
    }

    return Boolean(event && (
      event.type === 'cart:updated' ||
      event.type === 'cart:build'
    ));
  }

  function trackKnownCart(cart) {
    cartMutationMayContainGatedSku = false;
    lastCart = cart;
    setCartFormsKnownGated(cartContainsGatedSku(cart));
    return cart;
  }

  function applyFreshCartPayload(cart) {
    if (!cart) {
      return null;
    }

    trackKnownCart(cart);
    applyCartGuard(cart);
    return cart;
  }

  function cartEventMayAffectGatedItems(event) {
    if (!event) {
      return true;
    }

    var cart = eventCart(event);
    if (cart) {
      applyFreshCartPayload(cart);
      return false;
    }

    if (event.type === 'ajaxProduct:added') {
      var addedSku = eventProductSku(event);
      if (addedSku) {
        if (!gatedSkuSet[addedSku]) {
          return false;
        }

        cartMutationMayContainGatedSku = true;
        return true;
      }

      cartMutationMayContainGatedSku = true;
      return true;
    }

    if (isUnverifiedCartMutationEvent(event)) {
      cartMutationMayContainGatedSku = true;
      return true;
    }

    return !lastCart || cartContainsGatedSku(lastCart);
  }

  function findCartLineFromQuantityEvent(event) {
    if (!lastCart || !event || !event.detail) {
      return null;
    }

    var key = event.detail[0];
    var wrapper = event.detail[2];
    var input = wrapper && wrapper.querySelector && wrapper.querySelector('[data-id], [data-varid]');
    var variantId = input && input.getAttribute('data-varid');

    return (lastCart.items || []).find(function(item) {
      return (key && item.key === key) || (variantId && String(item.id) === String(variantId));
    }) || null;
  }

  function cartQuantityEventMayAffectGatedItems(event) {
    var lineItem = findCartLineFromQuantityEvent(event);
    if (lineItem) {
      return Boolean(gatedSkuSet[lineItem.sku]);
    }

    return cartKnownToContainGatedSku();
  }

  function hasPendingCartQuantity() {
    for (var key in cartQuantityPendingKeys) {
      if (Object.prototype.hasOwnProperty.call(cartQuantityPendingKeys, key)) {
        return true;
      }
    }
    return false;
  }

  function cartQuantityKeyOf(value) {
    // The cart:quantity START event carries [key, qty, wrapper]; the trailing
    // cart:updated carries detail.cartQuantityKey (threaded from sendQuantityChange).
    // Fall back to a shared sentinel so a key-less event still tracks SOMETHING
    // (degrades to the old single-bucket behavior) rather than going untracked.
    return String(value == null ? '__cart-quantity__' : value);
  }

  function clearCartQuantityPendingKey(key) {
    key = cartQuantityKeyOf(key);
    if (Object.prototype.hasOwnProperty.call(cartQuantityPendingKeys, key)) {
      window.clearTimeout(cartQuantityPendingKeys[key]);
      delete cartQuantityPendingKeys[key];
    }
  }

  function armCartQuantityPending(key) {
    key = cartQuantityKeyOf(key);
    if (Object.prototype.hasOwnProperty.call(cartQuantityPendingKeys, key)) {
      window.clearTimeout(cartQuantityPendingKeys[key]);
    }
    // Per-key backstop: if this line's write never broadcasts a trailing event
    // (a failed/challenged write), its own timer still discharges it — and only
    // re-evaluates the guard once NO other line is still pending, so one line's
    // backstop can't re-enable checkout while another increase is in flight.
    cartQuantityPendingKeys[key] = window.setTimeout(function() {
      delete cartQuantityPendingKeys[key];
      if (!hasPendingCartQuantity()) {
        refreshCartGuard(true);
        refreshProductLimits();
      }
    }, CART_QUANTITY_BACKSTOP_MS);
  }

  function handleCartQuantityStart(event) {
    if (!cartQuantityEventMayAffectGatedItems(event)) {
      return;
    }

    setCartFormsPending(CART_PENDING_MESSAGE);
    armCartQuantityPending(eventDetail(event)[0]);
  }

  function scheduleCartRefresh(event) {
    // Discharge quantity-mutation pending state PER LINE KEY, only on that line's
    // own trailing event (sendQuantityChange broadcasts source 'cart-quantity' and
    // threads the line key as detail.cartQuantityKey). Clearing only the matching
    // key means a second gated line's pending state + backstop survive the first
    // line's resolution, so applyCartGuard keeps checkout disabled until every
    // in-flight quantity mutation settles (or its own backstop fires). Unrelated
    // cart:updated events (remove/clear/other source) match no key and are safely
    // ignored by applyCartGuard's hasPendingCartQuantity short-circuit.
    if (event && event.type === 'cart:updated' && eventDetail(event).source === 'cart-quantity') {
      var cartQuantityKeys = eventDetail(event).cartQuantityKeys;
      if (Array.isArray(cartQuantityKeys)) {
        cartQuantityKeys.forEach(function(key) {
          clearCartQuantityPendingKey(key);
        });
      }
      clearCartQuantityPendingKey(eventDetail(event).cartQuantityKey);
    }

    var cart = eventCart(event);
    if (!cartEventMayAffectGatedItems(event)) {
      // Authoritative cart in hand: cartEventMayAffectGatedItems already re-ran
      // the guard from this payload (applyFreshCartPayload), so a verification
      // /cart.js read armed by a preceding optimistic add is now redundant —
      // cancel it (the F1 footprint win). Three guards on the cancel:
      //   1. No pending uncorrelated self-heal obligation. A non-optimistic read
      //      (e.g. armed by a stateless cart:build from an out-of-band Swym add,
      //      which fires no follow-up cart:updated) exists only to read the true
      //      post-write cart; an authoritative add must never consume it — even if
      //      an optimistic add later re-armed the SAME shared timer on top of it.
      //   2. Only a GENERATION-TAGGED read may be cancelled (target !== null).
      //   3. Cancel only once an authoritative event for the NEWEST optimistic
      //      add lands (authGeneration >= target): a rapid second add (B) arms the
      //      read, then the first add's (A) authoritative event can land first
      //      carrying pre-B state — cancelling on A would drop B's fail-closed
      //      read. Until it catches up the read stays armed and B's own
      //      authoritative event (or the backstop) settles it.
      if (cart) {
        refreshProductLimits(cart);
        var authGeneration = eventDetail(event).optimisticGeneration;
        if (cartRefreshTimer !== null &&
            !cartRefreshSelfHealPending &&
            cartRefreshTargetGeneration !== null &&
            typeof authGeneration === 'number' &&
            authGeneration >= cartRefreshTargetGeneration) {
          window.clearTimeout(cartRefreshTimer);
          cartRefreshTimer = null;
          cartRefreshTargetGeneration = null;
        } else if (cartRefreshTimer !== null) {
          // The cancel didn't fire, so a pending obligation remains — a NEWER
          // optimistic add still unresolved, or an uncorrelated self-heal read —
          // and this cart predates it. cartEventMayAffectGatedItems already ran
          // applyCartGuard from this (stale) payload, which may have re-enabled
          // checkout; re-assert pending so it stays disabled until the obligation
          // is settled (the newest add's authoritative event, or the read).
          setCartFormsPending(CART_PENDING_MESSAGE);
        }
      }
      return;
    }

    setCartFormsPending(CART_PENDING_MESSAGE);

    // Optimistic add events carry a monotonic optimisticGeneration and a null
    // cart. Record the newest generation so the consume branch can cancel the
    // read only once the authoritative event for that add lands.
    var detail = eventDetail(event);
    // A FORWARD optimistic add (not a revert) is the only event that SETS a
    // generation tag, and an unresolved tag (cartRefreshTargetGeneration !== null)
    // is what owes the long backstop. A revert means that add FAILED — cart
    // unchanged — so it DISCHARGES the tag (below) and the read falls back to the
    // prompt self-heal delay.
    var optimisticForwardAdd = Boolean(detail.optimistic) && !detail.optimisticRevert &&
      typeof detail.optimisticGeneration === 'number';
    if (optimisticForwardAdd) {
      cartRefreshTargetGeneration = cartRefreshTargetGeneration === null
        ? detail.optimisticGeneration
        : Math.max(cartRefreshTargetGeneration, detail.optimisticGeneration);
    } else {
      // A non-forward may-affect event — a stateless cart:build, or an optimistic
      // revert — creates an uncorrelated self-heal obligation that only a real
      // read can discharge. Recording it separately means a later optimistic add
      // re-arming the shared timer can't let its authoritative event cancel this
      // read out from under us.
      cartRefreshSelfHealPending = true;
      // A revert IS the resolution of the forward add it carries (the add failed,
      // cart unchanged), so its backstop obligation is discharged. Clear the
      // matching target generation so this self-heal keeps the prompt 150ms read
      // instead of being held to the now-pointless 2500ms add backstop.
      if (detail.optimisticRevert &&
          typeof detail.optimisticGeneration === 'number' &&
          cartRefreshTargetGeneration !== null &&
          detail.optimisticGeneration >= cartRefreshTargetGeneration) {
        cartRefreshTargetGeneration = null;
      }
    }

    // Delay keys off the pending OBLIGATION, not off which event armed the timer.
    // While any forward add is unresolved (cartRefreshTargetGeneration !== null)
    // the shared timer holds the long backstop — even when an unrelated cart:build
    // self-heal re-arms it (either interleave order) — so re-arming can never
    // shorten an in-flight add's backstop and let a stale pre-add read re-enable
    // checkout. Waiting longer is always the safe direction (checkout stays
    // disabled); the only cost is a slower re-enable in the rare add+build overlap.
    window.clearTimeout(cartRefreshTimer);
    cartRefreshTimer = window.setTimeout(function() {
      cartRefreshTimer = null;
      cartRefreshTargetGeneration = null;
      cartRefreshSelfHealPending = false;
      refreshCartGuard(true);
      refreshProductLimits();
    }, cartRefreshTargetGeneration !== null ? CART_OPTIMISTIC_REFRESH_MS : CART_REFRESH_MS);
  }

  document.addEventListener('submit', function(event) {
    var form = event.target && event.target.closest && event.target.closest('#CartPageForm, .cart__drawer-form');

    if (!form || (form.dataset.aerosolLimitBlocked !== 'true' && form.dataset.aerosolLimitPending !== 'true')) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    var notice = form.querySelector('[data-aerosol-limit-cart-message]');
    if (!notice && form.dataset.aerosolLimitPending === 'true') {
      notice = ensureCartNotice(form);
      showInlineMessage(notice, CART_PENDING_MESSAGE, false);
    } else if (notice) {
      notice.hidden = false;
    }

    if (notice) {
      notice.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
  }, true);

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('[data-aerosol-limit-product]').forEach(function(scriptEl) {
      initProductLimit(scriptEl);
    });

    refreshCartGuard(true);
  });

  ['ajaxProduct:added', 'cart:updated', 'cart:build'].forEach(function(eventName) {
    document.addEventListener(eventName, scheduleCartRefresh);
  });

  ['cart:quantity.cart-page', 'cart:quantity.cart-header'].forEach(function(eventName) {
    document.addEventListener(eventName, handleCartQuantityStart);
  });

  // When the edge challenge clears (the ~30s timer or a recovered cart read), the
  // cart is readable again — re-run the guard so a checkout that was disabled
  // while challenged self-heals without needing a user gesture or a page reload.
  document.addEventListener('cart:challenge:cleared', function() {
    refreshCartGuard(true);
    refreshProductLimits();
  });
})();
